import React from 'react';
import PropTypes from 'prop-types';
import styles from './Service.scss';
import blockStyles from "@baseStyles/block.scss";
import Button from "@components/base/Button/Button";
import Price, {getPriceId} from "@components/base/Price/Price";
import language from "@lang/language";
import useDataFileAction from "@hooks/useDataFileAction";

const Service =
  ({
	   serviceId,
	   term,
	   color = '',
	   title,
	   description = '',
	   descriptionSmall = '',
	   characteristics = '',
	   breadCrumbMode = '',
	   promoCode = '',
	   showMonthlyPrice = true,
	   icon = null,
	   circleIcon = null,
	   flagText = '',
	   buttonText = 'Поръчай сега',
	   buttonAction = '',
	   buttonParams = [],
	   ButtonModal = '',
	   actionLinks = []
   }) => {

	  if (!serviceId || !title) {
		  return null;
	  }

	  const servicePriceId = getPriceId(serviceId, term);
	  const {executeAction, ModalPortal} = useDataFileAction({
		  serviceId: serviceId,
		  servicePriceId: servicePriceId,
		  term: term,
		  breadCrumbMode: breadCrumbMode,
		  promoCode: promoCode,
		  color: color
	  });

	  return (
		<div
		  className={`${styles.container} ${flagText ? styles.preferredBorder : ''} ${color ? styles[color] : ''}`}>
			{/* Flag text */}
			{flagText && <div className={styles.flag}>{flagText}</div>}

			{/* Icon */}
			{icon &&
			  <div className={styles.icon}>
				  <div className={styles.circle}>
					  <img
						src={circleIcon}
						alt={'badge ' + title}
						title={title + language.shBGTitle}
						width={48}
						height={48}
					  />
				  </div>
				  <img
					src={icon}
					alt={title}
					title={title + language.shBGTitle}
					width={96}
					height={96}
				  />
			  </div>
			}

			{/* Block content */}
			<div className={styles.content}>
				{/* Title */}
				<h2 className={blockStyles.h4}>{title}</h2>

				{/* Description */}
				{description &&
				  <div className={blockStyles.p} dangerouslySetInnerHTML={{__html: description}}/>
				}

				{/* Characteristics */}
				{characteristics &&
				  <div className={blockStyles.p} dangerouslySetInnerHTML={{__html: characteristics}}/>
				}

				{/* Action links */}
				{actionLinks && actionLinks.length > 0 &&
				  <>
					  {actionLinks.map((item, key) => (
						<a
						  href={'#'}
						  key={key}
						  onClick={(e) => {
							  e.preventDefault();
							  executeAction(item);
						  }}>
							{item.text}
						</a>
					  ))}
				  </>
				}

				{/* Small description */}
				{descriptionSmall &&
				  <div className={blockStyles.note} dangerouslySetInnerHTML={{__html: descriptionSmall}}/>
				}

				<div className={blockStyles.mtAuto}>
					{/* Price */}
					<Price
					  serviceId={serviceId}
					  term={term}
					  layout={'PriceA'}
					  showMonthly={showMonthlyPrice}
					/>
				</div>

				{/* Button */}
				<Button
				  value={buttonText}
				  onClick={() => executeAction({
					  ButtonModal: ButtonModal,
					  buttonAction: buttonAction,
					  buttonParams: buttonParams
				  })}
				/>
			</div>

			{/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
			{/*///////////////////////////////////////////////////////////////////////////////*/}
			{ModalPortal}
			{/*///////////////////////////////////////////////////////////////////////////////*/}
		</div>
	  );
  };

Service.propTypes = {
	serviceId: PropTypes.string.isRequired,
	term: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	color: PropTypes.string,
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	descriptionSmall: PropTypes.string,
	characteristics: PropTypes.string,
	breadCrumbMode: PropTypes.string,
	promoCode: PropTypes.string,
	showMonthlyPrice: PropTypes.bool,
	icon: PropTypes.string,
	circleIcon: PropTypes.string,
	flagText: PropTypes.string,
	buttonText: PropTypes.string,
	buttonAction: PropTypes.string,
	buttonModal: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object
	]),
	actionLinks: PropTypes.array,
};

export default Service;